import type { FormEvent } from 'react';
import { useCallback } from 'react';

export const noop = () => {};

export const usePreventSubmit = () =>
    useCallback((event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    }, []);

export const formatRegion = (name: string, type: string) => {
    if (['г', 'респ'].includes(type.toLowerCase()) || name.includes(' ')) {
        return name;
    }

    return `${name} ${type}`;
};
